export default Object.freeze({
  OFFERED: 'OFF',
  ADMITTED: 'ADM',
  PASS: 'PASS',
  LOA:'LOA',
  POTENTIALLYCOMPLETE:'POTC',
  CONDITIONALLYCOMPLETE:'CONDC'  
})
